export default "__VITE_PUBLIC_ASSET__666796d4__"